export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          {/* Phone mockup */}
          <div className="shrink-0 relative">
            <div className="w-[220px] h-[440px] bg-foreground-900 rounded-[2rem] p-2 shadow-sm">
              <div className="w-full h-full rounded-[1.7rem] overflow-hidden bg-background-100 flex flex-col">
                {/* Mock status bar */}
                <div className="h-8 bg-background-50 flex items-center justify-center text-[10px] text-foreground-400">
                  天天影视
                </div>
                {/* Mock content */}
                <div className="flex-1 p-3 space-y-3 overflow-hidden">
                  <div className="h-3 w-16 bg-primary-200 rounded-full"></div>
                  <div className="space-y-2">
                    <div className="h-20 bg-background-200/70 rounded-lg"></div>
                    <div className="h-20 bg-background-200/70 rounded-lg"></div>
                    <div className="h-20 bg-background-200/70 rounded-lg"></div>
                    <div className="h-20 bg-background-200/70 rounded-lg"></div>
                  </div>
                </div>
                {/* Mock bottom nav */}
                <div className="h-10 bg-background-50 border-t border-background-200/70 flex items-center justify-around text-[10px] text-foreground-400">
                  <span>首页</span>
                  <span className="text-primary-500 font-semibold">综艺</span>
                  <span>搜索</span>
                  <span>我的</span>
                </div>
              </div>
            </div>
            {/* Glow */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[180px] h-8 bg-primary-500/20 blur-xl rounded-full pointer-events-none"></div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
              随时随地
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-4">
              天天影视 · 掌上综艺
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              下载天天影视移动端，高清综艺随时随地在线观看。通勤路上、午休间隙，打开手机就能追最新综艺，流畅不缓冲，和电脑端完全同步。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mb-6">
              <div className="flex items-center gap-2 bg-foreground-900 text-background-50 px-5 py-3 rounded-xl cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-fill text-xl"></i>
                <div className="text-left">
                  <div className="text-[10px] opacity-70">Download on the</div>
                  <div className="text-sm font-semibold">App Store</div>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-foreground-900 text-background-50 px-5 py-3 rounded-xl cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-google-play-fill text-xl"></i>
                <div className="text-left">
                  <div className="text-[10px] opacity-70">GET IT ON</div>
                  <div className="text-sm font-semibold">Google Play</div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1"><i className="ri-shield-check-line text-primary-500"></i> 安全下载</span>
              <span className="flex items-center gap-1"><i className="ri-smartphone-line text-primary-500"></i> iOS / Android</span>
              <span className="flex items-center gap-1"><i className="ri-cloud-line text-primary-500"></i> 与网页同步</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}